import { makeStyles } from '@mui/styles';
import TextField from 'apollo-react/components/TextField';
import Typography from 'apollo-react/components/Typography';
import React, { useEffect, useState } from 'react';

import CustomTooltip from './CustomTooltip';
import {
  FIELDS_FIELD_NAME,
  FIELDS_LABEL,
  RELATIONS_PARENT_OBJECT_KEY,
  RELATIONS_PARENT_TABLE_OBJECT_KEY_COLUMN,
  RELATIONS_SUB_ENTITY_ID,
} from '../../../../constants/entity-designer.constants';
import {
  getIsCellDisabled,
  getIsRequired,
  getIsViewOnly,
} from '../../../../utils/entity-designer.utils';

const useStyles = makeStyles({
  fieldNameCell: {
    display: 'flex',
    flexDirection: 'column',
  },
});

const ViewOnlyCell = ({ key, row }) => {
  const classes = useStyles();

  return (
    <>
      {key === FIELDS_FIELD_NAME ? (
        <div className={classes.fieldNameCell}>
          <Typography variant="caption">{row[key]}</Typography>
          {key === FIELDS_FIELD_NAME && row.TranslatedFieldName && (
            <Typography variant="caption">{`(${row.TranslatedFieldName})`}</Typography>
          )}
        </div>
      ) : (
        row[key]
      )}
    </>
  );
};

const EditableCell = ({ row, column: { accessor: key } }) => {
  const [value, setValue] = useState(row[key]);
  const isRelationTableFieldsWithCharMax = [
    RELATIONS_PARENT_OBJECT_KEY,
    RELATIONS_PARENT_TABLE_OBJECT_KEY_COLUMN,
    RELATIONS_SUB_ENTITY_ID,
  ].includes(key);

  useEffect(() => {
    setValue(row[key]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [row[key]]);

  const isDisabled = getIsCellDisabled({ key, row });
  const viewOnly = getIsViewOnly({ key, row });
  const required = getIsRequired({ key, row });
  const error = row.errors?.find((error) => error?.controlInfo?.prop === key);

  const onBlur = ({ target }) => {
    if (row[key] === target.value) {
      return;
    }
    row.editRow({ rowId: row.rowId, key, value: target.value, error });
  };

  return row.isEditMode && !viewOnly ? (
    <CustomTooltip prop={key}>
      <TextField
        size="small"
        fullWidth
        asteriskPosition="before"
        value={value ?? ''}
        disabled={isDisabled}
        required={required}
        helperText={
          key === FIELDS_LABEL && row.translatedFieldLabel && `(${row.translatedFieldLabel})`
        }
        onChange={({ target }) => setValue(target.value)}
        onBlur={onBlur}
        error={!!error}
        inputProps={{
          maxLength: isRelationTableFieldsWithCharMax ? 25 : undefined,
          'aria-label': row.TranslatedFieldName,
        }}
      />
    </CustomTooltip>
  ) : (
    ViewOnlyCell({ key, row })
  );
};
export default EditableCell;
